import { render, staticRenderFns } from "./CompletedMatches.vue?vue&type=template&id=14a167b6&scoped=true&"
import script from "./CompletedMatches.vue?vue&type=script&lang=js&"
export * from "./CompletedMatches.vue?vue&type=script&lang=js&"
import style0 from "./CompletedMatches.vue?vue&type=style&index=0&id=14a167b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a167b6",
  null
  
)

export default component.exports